module.exports = __webpack_public_path__ + "static/media/cs_icon.a17e02a1.svg";